exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1\n{\nfont-family: 'News Cycle', sans-serif;\n}\narticle\n{\n    padding-bottom: 20px;\n}\n.article-caption\n{\nposition: absolute;\nbottom: 16px;\nmax-width: 90%;\ntext-align: center;\nbackground-color: rgba(200,200,200,0.5);\n\n}\n\n.article-img\n{\nwidth: 100%; \nmax-height: 400px;\n-o-object-fit: cover;\n   object-fit: cover;\n}\n\n\n@media screen and (max-width: 768px) { \n.article-title\n{\nfont-size: 28px;\n}\n}\n\n@media screen and (max-width: 500px) { \n.article-title\n{\nfont-size: 20px;\n}\n}\n\n.article-caption a\n{\ncolor: white;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/globant/site/src/app/components/careers/careers.component.css
// module id = ../../../../../src/app/components/careers/careers.component.css
// module chunks = main